import { GenericTableDropdownActions } from "components/GenericTableDropdownActions";
import { Organismo } from "dtos/organismo";
import { OrganismoI } from "interfaces/Organismo";
import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { OrganismosABM } from "screens/Notificaciones/components/OrganismosABM/OrganismosABM";
import { useOrganismosList } from "./OrganismosListCtx";
import { RawModalConfirm } from "components/ModalConfirm/RawModalConfirm";
import { deleteOrganismo } from "services/organismos";

export function OrganismosTableRowActions({ organismo }: {
  organismo: Organismo;
})
{
  const [ action, setAction ] = useState<"edit"|"delete"|null>(null);
  const {
    onOrgamismoUpdated,
    onOrgamismoDeleted,
  } = useOrganismosList();

  return (
<>
  <GenericTableDropdownActions>

    <Dropdown.Item onClick={() =>
      {
        setAction("edit");
      }}
    >
      Editar
    </Dropdown.Item>

    <Dropdown.Item onClick={() =>
      {
        setAction("delete");
      }}
    >
      Eliminar
    </Dropdown.Item>

  </GenericTableDropdownActions>

  <OrganismosABM
    elemento={organismo}
    showModal={action == "edit"}
    actionType={action == "edit" ? "edit" : undefined}
    onClose={() =>
    {
      setAction(null);
    }}
    onSuccess={(newEl: OrganismoI) => onOrgamismoUpdated(newEl)}
  />

  <RawModalConfirm
    show={action == "delete"}
    title="Eliminar organismo"
    message={
      <p>
        Estas por eliminar el organismo {organismo.nombre} <br />
        <b>¿Querés realizar esta acción? Esta acción es irreversible.</b>
      </p>
    }
    onClose={() =>
    {
      setAction(null);
    }}
    onConfirm={async () =>
    {
      return deleteOrganismo(organismo.id).then(() => onOrgamismoDeleted(organismo.id))
    }}
  />
</>
  )
}